<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-35">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>security</md-icon>권한 그룹
            </h4>
          </md-card-header>
          <md-card-content>
            <grid ref="menuGrpGrid"
                  :data="gridGrpProps.data"
                  :columns="gridGrpProps.columns"
                  :options="gridGrpProps.options"
                  :theme="gridGrpProps.theme"
                  :rowHeaders="gridGrpProps.rowHeaders"
                  :columnOptions="gridGrpProps.columnOptions"
                  :language="gridGrpProps.lang"
                  @dblclick="onDblClickMenuGrp"
                  @click="onClickMenuGrp"></grid>
          </md-card-content>
          <md-card-actions md-alignment="right">
            <md-button class="md-info md-sm" @click="openMenuGrpPopup" v-auth-btn="[5,3]">
              <md-icon>check</md-icon>권한그룹 등록
            </md-button>
          </md-card-actions>
        </md-card>
      </div>
     
      <div class="md-layout-item md-size-65">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>view_compact</md-icon>화면 목록
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="table-header-info" >
              <div class="md-size-20">
                <span>총 {{ menuTotalCount }} 화면</span>
              </div>
              <md-card-actions md-alignment="space-between">
                <div style="display:inline-flex;" md-alignment="space-between">
                    <md-button class="md-info md-sm"  @click="saveMenuGrpMenu" v-auth-btn="[5,3]">
                      <md-icon>check</md-icon>메뉴 저장[권한그룹]
                    </md-button>&nbsp;&nbsp;
                    <md-button class="md-info md-sm" @click="openMenuPopup" v-auth-btn="[5,3]">
                      <md-icon>check</md-icon>메뉴 등록
                    </md-button>
                </div>
              </md-card-actions>
            </div>

            <grid ref="menuGrid"
                  :data="gridProps.data"
                  :columns="gridProps.columns"
                  :options="gridProps.options"
                  :theme="gridProps.theme"
                  :rowHeaders="gridProps.rowHeaders"
                  :columnOptions="gridProps.columnOptions"
                  :language="gridProps.lang"
                  @dblclick="onDblClickMenu"
                  @click="onClickMenu"
                  @response="response"></grid>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <!--권한그룹 신규생성  -->
    <modal v-if="isShowMenuGrpModal" class="search-friend-modal">
      <template slot="header">
        <h4 class="modal-title">권한그룹 등록(변경)</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="() => {this.isShowMenuGrpModal = false}">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <div class="md-layout">
          <table class="flex-table">
            <tr>
              <th>권한그룹 ID</th>
              <td v-if="isEdit"><input type="text" v-model="menuGrpData.menuGrpId" disabled></td>
              <td v-if="!isEdit"><input type="text" v-model="menuGrpData.menuGrpId"></td>
              <th>권한그룹명</th>
              <td><input type="text" v-model="menuGrpData.menuGrpNm"></td>
              <th>정렬순서</th>
              <td><input type="text" v-model="menuGrpData.menuGrpOrdr"></td>
              <th>사용여부</th>
              <td>
                 <select v-model="menuGrpData.useYn">
                  <option value="Y">Y</option>
                  <option value="N">N</option>
                 </select>
              </td>
            </tr>
          </table>
        </div>
      </template>
      <template slot="footer">
        <md-button class="md-info md-sm" @click="saveMenuGrp">저장</md-button>
        <md-button class="md-default md-sm" @click="() => {this.isShowMenuGrpModal = false; this.isEdit = false;}">취소</md-button>
      </template>
    </modal>

    <!--메뉴 입력/수정 팝업 -->
    <modal v-if="isShowMenuModal" class="search-friend-modal">
      <template slot="header">
        <h4 class="modal-title">메뉴 등록(변경)</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="() => {this.isShowMenuModal = false}">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <div class="md-layout">
          <table class="flex-table">
            <tr>
              <th>메뉴 ID</th>
              <td v-if="isMenuEdit"><input type="text" v-model="menuData.menuId" disabled></td>
              <td v-if="!isMenuEdit"><input type="text" v-model="menuData.menuId" v-mask="'##########'"></td>
              <th>메뉴명</th>
              <td colspan="2"><input type="text" v-model="menuData.menuNm"></td>
              <th>메뉴URL</th>
              <td colspan="2"><input type="text" v-model="menuData.menuUrl"></td>
            </tr>
            <tr>
              <th>상위메뉴ID</th>
              <td><input type="text" v-model="menuData.upperMenuId"></td>
<!--              
              <th>메뉴구분</th>
              <td>
                <input type="text" disabled value="메뉴">
                <input type="hidden" v-model="menuData.menuGbCd">
              </td>
-->
              <th>노출여부</th>
              <td>
                <select v-model="menuData.expoYn">
                  <option value="Y">Y</option>
                  <option value="N">N</option>
                </select>
              </td>
              <th>사용여부</th>
              <td>
                <select v-model="menuData.useYn">
                  <option value="Y">Y</option>
                  <option value="N">N</option>
                </select>
              </td>
              <th>정렬순서</th>
              <td><input type="text" v-model="menuData.menuOrdr"></td>
            </tr>
          </table>
        </div>
      </template>
      <template slot="footer">
        <md-button class="md-info md-sm" @click="saveMenu">저장</md-button>
        <md-button class="md-default md-sm" @click="() => {this.isShowMenuModal = false; this.isMenuEdit = false;}">취소</md-button>
      </template>
    </modal>
  </div>
</template>

<script>
import {Modal} from "@/components";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaApi from "@/kuaa/kuaa-api";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import Swal from "sweetalert2";

export default {
  components: {
    Modal,
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  computed: {
  },

  data(){
    return{
      menuTotalCount: 0,
      menuGrpData: {},
      menuData: {},
      isShowMenuGrpModal: false,
      isShowMenuModal: false,
      isEdit: false,
      isMenuEdit: false,
      
      pagination: {
        page: 1,
        perPage: 100,
        currentPage: 1,
        total: 0
      }
    }
  },

  methods: {
    initGrid() {

      this.gridGrpProps = kuaaFnc.setGridInit(URL_CONST.GET_MENU_GRP_LIST, true, null, ['rowNum']);
      this.gridGrpProps['el'] = this.$refs.menuGrpGrid;
      this.gridGrpProps['columns'] = [
        {header: '선택', name: 'check', align : 'center', width:50,
          formatter(value) {
            return '<input type="radio" id="' + value.row.menuGrpId + '" name="selectedSRow">';
          }
        },
        {header: '권한그룹ID', name: 'menuGrpId', align: "center"},
        {header: '권한그룹명', name: 'menuGrpNm', align: "center"},
        {header: '정렬순서', name: 'menuGrpOrdr', align: "center"},
        {header: '사용여부', name: 'useYn', align: "center"}
      ];

      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_MENU_LIST, false, this.pagination, ['rowNum']);
      this.gridProps['el'] = this.$refs.menuGrid;
      this.gridProps['columns'] = [
        {header: '선택', name: 'checked', align: "center", width:50,
          formatter(value) {
            return '<input type="checkbox" id="' + value.row.menuId + '" name="selectedRow" ' + (value.row.checked=="Y"? 'checked>' : '>');
          }
        },
        {header: '메뉴ID', name: 'menuId', align: "center"},
        {header: '메뉴명', name: 'menuNm', width:"auto"},
        {header: '메뉴URL', name: 'menuUrl', align: "left", width:"auto"},
        {header: '상위메뉴ID', name: 'upperMenuId', align: "center"},
        {header: '노출여부', name: 'expoYn', align: "center"},
        {header: '사용여부', name: 'useYn', align: "center"},
        {header: '정렬순서', name: 'menuOrdr', align: "center"},
        {header: '메뉴구분', name: 'menuGbCd', hidden:true},
        {header: '메뉴상세', name: 'menuDesc', hidden:true},
        {header: '버튼그룹ID', name: 'btnGrpId', hidden:true},
        {header: '버튼그룹명', name: 'btnGrpNm', hidden:true},
        {header: '버튼CSS명', name: 'btnCssNm', hidden:true}
      ];
      this.gridProps['options'].bodyHeight = 510;

    },

    response(e){
      let resUrl = e.xhr.responseURL;
      let res = JSON.parse(e.xhr.response);

      if(res.result){
        //  this.pagination.total = res.data.pagination.totalCount;
        this.menuTotalCount = res.data.pagination.totalCount;
          
      }else{
        kuaaFnc.showSwal("권한 관리", res.resultMessage);
        return false;
      }
    },

    onClickMenuGrp(e){
      let obj = e.instance.getRow(e.rowKey);
      if(obj != null  && e.columnName == 'check') {
        this.menuGrpData = obj;
        document.getElementById(obj.menuGrpId).checked = true;
        this.$refs.menuGrid.invoke("readData", this.$refs.menuGrid.invoke("getPagination")._currentPage, {menuGrpId: obj.menuGrpId});
      }
    },

    onDblClickMenuGrp(e){
      let obj = e.instance.getRow(e.rowKey);
      if(obj != null && e.columnName != 'check') {
        this.menuGrpData = obj;
        this.isEdit = true;
        this.isShowMenuGrpModal = true;
      }
    },

    openMenuGrpPopup(e){
      this.menuGrpData = {};
      this.menuGrpData.useYn = 'Y';
      this.menuGrpData.menuGrpOrdr = 99;
//      if(this.menuGrpData != null && this.menuGrpData.menuGrpId != null){
//        this.isEdit = true;
//      }else{
        this.isEdit = false;
//      }
      this.isShowMenuGrpModal = true;
    },
    
    onClickMenu(e){
      let obj = e.instance.getRow(e.rowKey);
      if(obj != null && e.columnName == 'checked') {
        if(obj.checked == 'Y')   this.$refs.menuGrid.invoke('setValue', e.rowKey, 'checked', 'N', false);
        else                     this.$refs.menuGrid.invoke('setValue', e.rowKey, 'checked', 'Y', false);
      }
    },

    onDblClickMenu(e){
      let obj = e.instance.getRow(e.rowKey);
      if(obj != null && e.columnName != 'check') {
        this.menuData = obj;
        this.isMenuEdit = true;
        this.isShowMenuModal = true;
      }
    },

    openMenuPopup(e){
      this.menuData = {};
      this.menuData.menuGbCd = '01';
      this.menuData.expoYn = 'Y';
      this.menuData.useYn = 'Y';
      this.menuData.menuOrdr = 99;
      this.isMenuEdit = false;
      this.isShowMenuModal = true;
    },
    
    saveMenuGrp(){
      this.isShowMenuGrpModal = false;

      let modalOptions = kuaaFnc.getSwalModaloptions('confirm', {
        html: "권한그룹 [" + this.menuGrpData.menuGrpId + "] 을 저장 하시겠습니까?"
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
              URL_CONST.SAVE_MENU_GRP,
              this.menuGrpData,
              "post",
              response => {
                if (response.data.success) {
                  this.menuGrpData = {};
                  kuaaFnc.showSwal("권한 관리");
                  this.$refs.menuGrpGrid.invoke("readData", 1, {});

                } else {
                  kuaaFnc.showSwal("권한 관리", response.data.resultMessage);
                  return false;
                }
              }
          );
        }
      });
    },
    
    
    saveMenuGrpMenu(){
      if(this.menuGrpData == null || this.menuGrpData.menuGrpId == null){
        kuaaFnc.showSwal("권한 관리", "권한그룹을 선택하세요");
        return false;
      }
      let menuGrpMenuMapList = [];

      this.$refs.menuGrid.invoke("getData").forEach(data => {
        if(data.checked == 'Y')   {
          menuGrpMenuMapList.push({menuGrpId: this.menuGrpData.menuGrpId, menuId:data.menuId});
        }
      });

      if(menuGrpMenuMapList.length == 0) {
        let modalOptions = kuaaFnc.getSwalModaloptions('confirm', {
          html: "권한그룹 [" + this.menuGrpData.menuGrpId + "] 의 모든 메뉴를 삭제 하시겠습니까?",
        });
        Swal.fire(modalOptions).then(result => {
          if (result.value) {
            kuaaApi.sendServer(
              URL_CONST.DELETE_MENU_GRP_MENU, 
              {menuGrpId: this.menuGrpData.menuGrpId}, 
              "post", 
              response => {
                if (response.data.success) {
                  kuaaFnc.showSwal("권한 관리", "권한그룹 [" + this.menuGrpData.menuGrpId + "] 의 모든 메뉴를 삭제 하였습니다.");
                  this.$refs.menuGrid.invoke("readData", 1, {codeGrpId: this.menuGrpData.menuGrpId});
  
                } else {
                  kuaaFnc.showSwal("권한 관리", response.data.resultMessage);
                }
              }
            );
          }
        })
      }else {

        let modalOptions = kuaaFnc.getSwalModaloptions('confirm', {
          html: "권한그룹 [" + this.menuGrpData.menuGrpId + "] 의 메뉴를 설정 하시겠습니까?"
        });

        Swal.fire(modalOptions).then(result => {
          if (result.value) {
            kuaaApi.sendServer(
              URL_CONST.SAVE_MENU_GRP_MENU_LIST,
              menuGrpMenuMapList,
              "post",
              response => {  
                if (response.data.success) {
                    kuaaFnc.showSwal("권한 관리");
                    this.$refs.menuGrid.invoke("readData", 1, {codeGrpId: this.menuGrpData.menuGrpId});
    
                  } else {
                    kuaaFnc.showSwal("권한 관리", response.data.resultMessage);
                  }
              }
            );
          }
        });
      }
    },

    saveMenu(){
      this.isShowMenuModal = false;

      let modalOptions = kuaaFnc.getSwalModaloptions('confirm', {
        html: "메뉴 [" + this.menuData.menuNm + "] 을 저장 하시겠습니까?"
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
              URL_CONST.SAVE_MENU,
              this.menuData,
              "post",
              response => {
                if (response.data.success) {
                  this.menuData = {};
                  kuaaFnc.showSwal("권한 관리", "메뉴를 저장하였습니다.");
                  this.$refs.menuGrid.invoke("readData", 1, {codeGrpId: this.menuGrpData.menuGrpId});

                } else {
                  kuaaFnc.showSwal("권한 관리", response.data.resultMessage);
                  return false;
                }
              }
          );
        }
      });
    },
  }
 }
</script>

<style>

</style>